import React, { useState } from "react";
import { Row, Col, Modal, Form, Button } from "react-bootstrap";
import OrgPickerModal from "organizations/OrgPickerModal";
import jsDig from "utils/jsDig";
import JoinOrg from "home/JoinOrg";

export default function ProfileDropdown(props) {
  let logout = require("images/lite/icons/logout.png");
  logout = <img className="logout-icon" style={{ paddingBottom: "3px", paddingRight: "12px" }} src={`/datapulse${logout}`} />;
  let dpLogo = require("images/logos/dp-logo-white.png");
  dpLogo = <img width="40" height="40" className="avatar-picker" style={{ paddingBottom: "3px", paddingRight: "1px" }} src={`/datapulse${dpLogo}`} />;
  let orgLogo = props.logo ? props.logo : "";
  orgLogo = <img width="40" hieght="40" className="avatar-picker" style={{ paddingBottom: "3px", paddingRight: "1px" }} src={`${orgLogo}`} />;

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const [showOrgOptions, setShowOrgOptions] = useState(false);
  const toggleOrgOptions = () => setShowOrgOptions(!showOrgOptions);
  const userOrgDetail = props.user_org_details.find((el) => el.organization_id == jsDig(["selected_org", "id"], props));
  const getRoleTitle = (role) => {
    switch (role) {
      case "admin":
        return "Admin";
      case "manager":
        return "Full";
      case "specialist":
        return "Standard";
      case "employee":
        return "Restricted";
      case "client":
        return "Client";
      default:
        return "Nobody";
    }
  };
  let dropdownArrow = require("images/lite/icons/chevron-down.png");
  dropdownArrow = <img className="dropdown-arrow" src={`/datapulse${dropdownArrow}`} style={{ transform: showOrgOptions ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }} />;

  return (
    <div className="profile-dropdown">
      {(props.organizations && props.organizations.length) > 0 && (
        <>
          <p className="mb-2 f10 text-right org-settings-dropdown" onClick={(e) => {e.stopPropagation(); toggleOrgOptions()}}>
            Organization: <b className="selected-org-name">{props.selected_org ? props.selected_org.name : "None"}</b>
            <span className="f10 text-info ml-1">
              {dropdownArrow}
            </span>
          </p>
    
          <div className={`top org-settings ${showOrgOptions ? "expanded" : ""}`} style={{ display: 'flex', flexDirection: 'column', margin: '8px 0' }}>
            <div style={{ padding: '0px 16px 8px 16px' }}>
              <div style={{ padding: '8px 0', display: 'flex', alignItems: 'center', gap: '4px' }}>
                <div style={{ flexBasis: '25%' }}>
                  {props.logo ? orgLogo : dpLogo}
                </div>
                <div style={{ flexGrow: 1, maxWidth: "100%", overflow: "hidden" }}>
                  <p style={{ whiteSpace: "nowrap" }} className="f16 selected-org-name">
                    {props.selected_org ? props.selected_org.name : "None"}
                  </p>
                  <p className="f12">
                    {props.current_user_is_owner ? "Owner" : getRoleTitle(jsDig(["role"], userOrgDetail))}
                  </p>
                </div>
              </div>
              {(props.organizations.length > 1 || !props.selected_org) && (
                <p onClick={handleShow} style={{ whiteSpace: "nowrap", filter: "brightness(100%)" }} className="f14 profile-dropdown-item text-info">
                  Change Organization
                </p>
              )}
              {(getRoleTitle(jsDig(["role"], userOrgDetail)) === "Admin" || props.current_user_is_admin || props.current_user_is_owner) && (
                <p className="f14">
                  <a className="profile-dropdown-item text-info" href={window.location.origin + "/datapulse/organization/" + jsDig(["selected_org", "id"], props)}>
                    Organization Settings
                  </a>
                </p>
              )}
              {props.current_user_is_god && ( 
                <p className="f14">
                  <a className="profile-dropdown-item text-info" href={window.location.origin + "/datapulse/org-management/"}>
                    Organization Management
                  </a>
                </p>
              )}
              <JoinOrg customBtnText={
                <>
                  <p style={{ whiteSpace: "nowrap", filter: "brightness(100%)" }} className="f14 profile-dropdown-item text-info">
                    Join Organization
                  </p>
                </>
              } />
            </div>
          </div>
        </>
      )}
      <Row className="bot mx-0 bottom">
        <Col>
          <p className="dropdown-name">
            {props.current_user.first_name} {props.current_user.last_name}
          </p>
          <a href={window.location.origin + "/datapulse/profile"} style={{ lineHeight: "1.5" }} className="f14 profile-dropdown-item dropdown-text">
            My Profile
          </a>
          {((["Standard", "Full", "Admin"].includes(getRoleTitle(jsDig(["role"], userOrgDetail)))) && props.is_primary_org) && (
            <>
              <a href={window.location.origin + "/datapulse/alerts"} style={{ lineHeight: "1.5" }} className="f14 profile-dropdown-item dropdown-text">
                Alerts
              </a>
            </>
          )}
          {((["Standard", "Full", "Admin"].includes(getRoleTitle(jsDig(["role"], userOrgDetail)))) && props.is_primary_org) && (
            <>
              <a href={window.location.origin + "/datapulse/reports"} style={{ lineHeight: "1.5" }} className="f14 profile-dropdown-item dropdown-text">
                Google Sheets Export
              </a>
            </>
          )}
          <hr></hr>
          {(getRoleTitle(jsDig(["role"], userOrgDetail)) == "Admin" || props.current_user_is_owner) && (
            <>
              <p className="dropdown-name">Admin</p>
              <a href={window.location.origin + "/datapulse/user-access"} style={{ lineHeight: "1.5" }} className="f14 profile-dropdown-item dropdown-text">
                User Access
              </a>
              <a
                href={window.location.origin + "/datapulse/account-management"}
                style={{ lineHeight: "1.5" }}
                className="f14 profile-dropdown-item dropdown-text">
                Manage My Accounts
              </a>
              <a href={window.location.origin + "/datapulse/api-access"} style={{ lineHeight: "1.5" }} className="f14 profile-dropdown-item dropdown-text">
                Data Connections
              </a>
              {((["Admin"].includes(getRoleTitle(jsDig(["role"], userOrgDetail))))) && (
                <>
                  <a href={window.location.origin + "/datapulse/spend-summary-report"} style={{ lineHeight: "1.5" }} className="f14 profile-dropdown-item dropdown-text">
                    Spend Summary Report
                  </a>
                </>
              )}
              <hr></hr>
            </>
          )}
          <a className="f14 profile-dropdown-item dropdown-text" rel="nofollow" data-method="delete" href={props.logout_path}>
            {logout}Logout
          </a>
        </Col>
      </Row>
      {props.organizations && props.organizations.length > 0 && (
        <OrgPickerModal show={show} setShow={setShow} selectedOrg={props.selected_org} organizations={props.organizations} />
      )}
    </div>
  );
}
